import { addDays } from "date-fns"

import { DateFormatType, formatDateRange, startOfDayUTC } from "~/utils/datetime"
import { formatNumber } from "~/utils/formatting"

export function formatDays(value: number): string {
  return `${formatNumber(value, value < 10 ? 1 : 0)} d`
}

export function formatPercent(value: number): string {
  return `${formatNumber(value * 100, 0)}%`
}

export function formatRate(value: number): string {
  return formatNumber(value, 2)
}

/** Whole units, with "<1" for a positive amount that rounds to 0 so it doesn't read as no sales. */
export function formatExpectedUnits(value: number | null | undefined): string {
  if (value == null) return ""
  if (value > 0 && value < 0.5) return "<1"
  return formatNumber(value, 0)
}

export function perDayOrDash(value: number | null | undefined): string {
  return value == null ? "—" : value.toFixed(2)
}

/** "Covers 22 Oct 2026 to 28 Oct 2026." for the `days` days ending on `end` ("YYYY-MM-DD"). */
export function windowCoverage(days: number, end: string | null): string {
  if (!end) return ""
  const endDate = startOfDayUTC(end)
  const startDate = addDays(endDate, 1 - days)
  return `Covers ${formatDateRange({ startDate, endDate, dateFormatType: DateFormatType.FullDateShort, separator: "to" })}.`
}

/** `tooltip` followed by the dates the `days`-day window ending on `end` covers. */
export function withWindowCoverage(
  tooltip: string | undefined,
  days: number,
  end: string | null,
): string | undefined {
  const coverage = windowCoverage(days, end)
  if (!coverage) return tooltip
  return tooltip ? `${tooltip} ${coverage}` : coverage
}
